"use client";
import { Html, If } from "@/Components";
import { CenterOptions } from "@/Helpers/CenterOptions";
import { CentersSectionProps } from "@/Templates/SectionsProps";
import { Col, Row } from "antd";
import { FC, useMemo } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Slider from "react-slick";
import CenterBranchItem from "../Components/CenterBranchItem";

interface ArrowProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}
const CustomNextArrow: React.FC<ArrowProps> = ({ onClick }) => (
  <div className="spciality-nav nav-bottom owl-nav">
    <button
      type="button"
      role="presentation"
      className="owl-next"
      onClick={onClick}
    >
      <FaChevronRight />
    </button>
  </div>
);

const CustomPrevArrow: React.FC<ArrowProps> = ({ onClick }) => (
  <div className="spciality-nav nav-bottom owl-nav">
    <button
      type="button"
      role="presentation"
      className="owl-prev"
      onClick={onClick}
    >
      <FaChevronLeft />
    </button>
  </div>
);
const Centers: FC<CentersSectionProps> = ({ setting, dataSource }) => {
  const Doctoroptions = {
    slidesToShow: 1, // پایه: موبایل
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: true,
    focusOnSelect: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      { breakpoint: 576, settings: { slidesToShow: 1 } }, // گوشی
      { breakpoint: 768, settings: { slidesToShow: 2 } }, // تبلت کوچک
      { breakpoint: 992, settings: { slidesToShow: 3 } }, // تبلت/لپتاپ
      { breakpoint: 1200, settings: { slidesToShow: 4 } }, // دسکتاپ
    ],
  };

  const content = useMemo(() => {
    switch (setting.ItemsDisplayMode?.Key) {
      case CenterOptions.SiteTemplate.SiteTemplateSettings.ItemsDisplayMode
        .Slider.key:
        return (
          <>
            <div
              className="doctors-slider slick-margins slick-arrow-center aos"
              data-aos="fade-up"
            >
              <Slider {...Doctoroptions}>
                {dataSource.Items.map((item) => (
                  <CenterBranchItem key={item.Id} model={item} />
                ))}
              </Slider>
            </div>
            <div className="doctor-nav nav-bottom owl-nav" />
          </>
        );
      default:
        return (
          <Row gutter={[8, 8]}>
            {dataSource.Items.map((item) => (
              <Col key={item.Id} xs={24} md={6}>
                <CenterBranchItem model={item} />
              </Col>
            ))}
          </Row>
        );
    }
  }, [dataSource.Items, setting.ItemsDisplayMode?.Key]);

  return (
    <section className="doctor-section">
      <div className="container">
        <If condition={setting.Title && setting.Description}>
          <div
            className="section-header sec-header-one text-center aos"
            data-aos="fade-up"
          >
            <span className="badge badge-primary">{setting.Title}</span>
            <h2>
              <Html value={setting.Description} />
            </h2>
          </div>
        </If>
        {content}
      </div>
    </section>
  );
};

export default Centers;
